export default {
    contractsList: [],
    numberOfResults: 1,
    userProcessdetailData: [],
    quizResultsData: [],
    courses: [
        "eng-breaking-revolution",
        "ulti-pronun",
        "com-fluency",
        "toeic",
        "native",
    ],
}